import { LogLevel } from "@azure/msal-browser";

export const msalConfiguration = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID, // "9f3a26ae-08af-4a12-9931-f6d98ba689aa", 
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`, // 213a54d8-2495-40c5-b3eb-94a86979dc0a
        redirectUri: "/callback",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // eslint-disable-next-line default-case
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

export const apiConfig = {
    resourceUri: process.env.REACT_APP_API_ENDPOINT,
    resourceScopes: [process.env.REACT_APP_AAD_SCOPE], // api://15a86f1f-59a4-46b0-89e8-7ea387d8f462/access_as_user
}

export const loginRequest = {
    scopes: ["openid", "profile", "email", ...apiConfig.resourceScopes]
};

export const silentRequest = {
    scopes: ["openid", "profile", "email", ...apiConfig.resourceScopes],
    loginHint: "example@domain.net"
};

export const tokenRequest = {
    scopes: [...apiConfig.resourceScopes]
}
